import React from 'react';
import { Link } from 'react-router-dom';
import './talentprogram.css';

const TalentProgram = () => {
    return (
        <div className="talent-program">
            {/* Hero Section */}
            <section className="program-hero">
                <div className="hero-background">
                    <div className="hero-shapes">
                        <div className="shape shape-1"></div>
                        <div className="shape shape-2"></div>
                        <div className="shape shape-3"></div>
                    </div>
                </div>
                <div className="container">
                    <div className="row align-items-center min-vh-100">
                        <div className="col-lg-10 mx-auto text-center">
                            <div className="hero-badge mb-4">
                                <span className="badge-text">🚀 Premium Talent Program</span>
                            </div>
                            <h1 className="hero-title mb-4">
                                Hire <span className="gradient-text">Top Tech Talent</span>
                                <br />from Abia Tech Hub Academy
                            </h1>
                            <p className="hero-subtitle mb-5">
                                Connect with verified, skilled graduates and build your dream tech team. 
                                Skip the lengthy recruitment process and find the perfect match for your company.
                            </p>
                            <div className="hero-stats mb-5">
                                <div className="stat-item">
                                    <div className="stat-number">9+</div>
                                    <div className="stat-label">Verified Talents</div>
                                </div>
                                <div className="stat-item">
                                    <div className="stat-number">100%</div>
                                    <div className="stat-label">Success Rate</div>
                                </div>
                                <div className="stat-item">
                                    <div className="stat-number">24/7</div>
                                    <div className="stat-label">Support</div>
                                </div>
                            </div>
                            <div className="hero-actions">
                                <Link to="/company-register" className="btn btn-primary btn-lg me-3">
                                    <i className="fas fa-rocket me-2"></i>Get Started Now
                                </Link>
                                <Link to="/talent-marketplace" className="btn btn-outline-light btn-lg">
                                    <i className="fas fa-users me-2"></i>Browse Talents
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Program Overview */}
            <section className="features-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto">
                            <div className="section-header text-center mb-5">
                                <div className="section-badge mb-3">
                                    <span className="badge-text">✨ Why Choose Us</span>
                                </div>
                                <h2 className="section-title mb-4">
                                    Bridge the Gap Between <span className="gradient-text">Talent & Opportunity</span>
                                </h2>
                                <p className="section-subtitle">
                                    We connect exceptional tech talent with forward-thinking companies, 
                                    creating perfect matches that drive innovation and growth.
                                </p>
                            </div>

                            <div className="features-grid">
                                <div className="feature-card">
                                    <div className="feature-icon">
                                        <div className="icon-bg">
                                            <i className="fas fa-graduation-cap"></i>
                                        </div>
                                    </div>
                                    <div className="feature-content">
                                        <h4>Verified Graduates</h4>
                                        <p>
                                            All our talents are verified graduates from our comprehensive tech programs, 
                                            ensuring quality and reliability you can trust.
                                        </p>
                                        <div className="feature-highlight">
                                            <span className="highlight-text">100% Verified</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="feature-card">
                                    <div className="feature-icon">
                                        <div className="icon-bg">
                                            <i className="fas fa-code"></i>
                                        </div>
                                    </div>
                                    <div className="feature-content">
                                        <h4>Real-World Skills</h4>
                                        <p>
                                            Our graduates are trained with industry-relevant skills and hands-on 
                                            experience in modern technologies and frameworks.
                                        </p>
                                        <div className="feature-highlight">
                                            <span className="highlight-text">Industry Ready</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="feature-card">
                                    <div className="feature-icon">
                                        <div className="icon-bg">
                                            <i className="fas fa-handshake"></i>
                                        </div>
                                    </div>
                                    <div className="feature-content">
                                        <h4>Direct Connection</h4>
                                        <p>
                                            Connect directly with talent, skip the lengthy recruitment process, 
                                            and find the perfect match for your team instantly.
                                        </p>
                                        <div className="feature-highlight">
                                            <span className="highlight-text">Instant Access</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="feature-card">
                                    <div className="feature-icon">
                                        <div className="icon-bg">
                                            <i className="fas fa-chart-line"></i>
                                        </div>
                                    </div>
                                    <div className="feature-content">
                                        <h4>Proven Track Record</h4>
                                        <p>
                                            Our graduates have successfully contributed to various projects and 
                                            companies across different industries worldwide.
                                        </p>
                                        <div className="feature-highlight">
                                            <span className="highlight-text">Proven Success</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How It Works */}
            <section className="process-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            <div className="section-header text-center mb-5">
                                <div className="section-badge mb-3">
                                    <span className="badge-text">🎯 Simple Process</span>
                                </div>
                                <h2 className="section-title mb-4">
                                    How It <span className="gradient-text">Works</span>
                                </h2>
                                <p className="section-subtitle">
                                    Three simple steps to find and hire the perfect tech talent for your team
                                </p>
                            </div>

                            <div className="process-timeline">
                                <div className="process-step">
                                    <div className="step-number">
                                        <span className="number">01</span>
                                    </div>
                                    <div className="step-content">
                                        <div className="step-icon">
                                            <i className="fas fa-search"></i>
                                        </div>
                                        <h4>Browse Talents</h4>
                                        <p>
                                            Explore our comprehensive database of verified graduates with detailed profiles, 
                                            skills, portfolios, and experience. Filter by specialization, location, and expertise.
                                        </p>
                                        <div className="step-features">
                                            <span className="feature-tag">Advanced Search</span>
                                            <span className="feature-tag">Detailed Profiles</span>
                                            <span className="feature-tag">Portfolio Access</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="process-step">
                                    <div className="step-number">
                                        <span className="number">02</span>
                                    </div>
                                    <div className="step-content">
                                        <div className="step-icon">
                                            <i className="fas fa-credit-card"></i>
                                        </div>
                                        <h4>Choose Your Plan</h4>
                                        <p>
                                            Select a subscription plan that perfectly fits your hiring needs and budget. 
                                            From basic access to enterprise solutions, we have options for every company size.
                                        </p>
                                        <div className="step-features">
                                            <span className="feature-tag">Flexible Plans</span>
                                            <span className="feature-tag">Budget Friendly</span>
                                            <span className="feature-tag">Scalable</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="process-step">
                                    <div className="step-number">
                                        <span className="number">03</span>
                                    </div>
                                    <div className="step-content">
                                        <div className="step-icon">
                                            <i className="fas fa-handshake"></i>
                                        </div>
                                        <h4>Connect & Hire</h4>
                                        <p>
                                            Get instant access to contact information and start building your dream team. 
                                            Connect directly with talent and begin the hiring process immediately.
                                        </p>
                                        <div className="step-features">
                                            <span className="feature-tag">Instant Access</span>
                                            <span className="feature-tag">Direct Contact</span>
                                            <span className="feature-tag">24/7 Support</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Available Specializations */}
            <section className="specializations-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            <div className="section-header text-center mb-5">
                                <div className="section-badge mb-3">
                                    <span className="badge-text">💼 Specializations</span>
                                </div>
                                <h2 className="section-title mb-4">
                                    Find Talent Across <span className="gradient-text">Tech Domains</span>
                                </h2>
                                <p className="section-subtitle">
                                    Our graduates specialize in cutting-edge technologies and modern development practices
                                </p>
                            </div>

                            <div className="specializations-grid">
                                <div className="spec-card">
                                    <div className="spec-icon">
                                        <i className="fas fa-shield-alt"></i>
                                    </div>
                                    <h5>Cyber Security</h5>
                                    <p>Network security, ethical hacking, risk assessment, compliance</p>
                                    <div className="spec-tags">
                                        <span className="tag">Security</span>
                                        <span className="tag">Ethical Hacking</span>
                                    </div>
                                </div>

                                <div className="spec-card">
                                    <div className="spec-icon">
                                        <i className="fas fa-code"></i>
                                    </div>
                                    <h5>Fullstack Development</h5>
                                    <p>Frontend, backend, database management, API development</p>
                                    <div className="spec-tags">
                                        <span className="tag">React</span>
                                        <span className="tag">Node.js</span>
                                    </div>
                                </div>

                                <div className="spec-card">
                                    <div className="spec-icon">
                                        <i className="fas fa-mobile-alt"></i>
                                    </div>
                                    <h5>Mobile Development</h5>
                                    <p>iOS, Android, cross-platform apps, React Native</p>
                                    <div className="spec-tags">
                                        <span className="tag">iOS</span>
                                        <span className="tag">Android</span>
                                    </div>
                                </div>

                                <div className="spec-card">
                                    <div className="spec-icon">
                                        <i className="fas fa-chart-bar"></i>
                                    </div>
                                    <h5>Data Analysis</h5>
                                    <p>Data visualization, analytics, reporting, machine learning</p>
                                    <div className="spec-tags">
                                        <span className="tag">Python</span>
                                        <span className="tag">Analytics</span>
                                    </div>
                                </div>

                                <div className="spec-card">
                                    <div className="spec-icon">
                                        <i className="fas fa-paint-brush"></i>
                                    </div>
                                    <h5>UI/UX Design</h5>
                                    <p>User interface, user experience, prototyping, design systems</p>
                                    <div className="spec-tags">
                                        <span className="tag">Figma</span>
                                        <span className="tag">Prototyping</span>
                                    </div>
                                </div>

                                <div className="spec-card">
                                    <div className="spec-icon">
                                        <i className="fas fa-cloud"></i>
                                    </div>
                                    <h5>Cloud Computing</h5>
                                    <p>AWS, Azure, Google Cloud, DevOps, infrastructure</p>
                                    <div className="spec-tags">
                                        <span className="tag">AWS</span>
                                        <span className="tag">DevOps</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Pricing Section */}
            <section className="pricing-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            <div className="section-header text-center mb-5">
                                <div className="section-badge mb-3">
                                    <span className="badge-text">💰 Flexible Pricing</span>
                                </div>
                                <h2 className="section-title mb-4">
                                    Choose Your <span className="gradient-text">Perfect Plan</span>
                                </h2>
                                <p className="section-subtitle">
                                    Transparent pricing with no hidden fees. Cancel anytime.
                                </p>
                            </div>

                            <div className="pricing-grid">
                                <div className="pricing-card">
                                    <div className="pricing-header">
                                        <h4>Basic</h4>
                                        <p>Perfect for small teams</p>
                                    </div>
                                    <div className="pricing-price">
                                        <span className="currency">₦</span>
                                        <span className="amount">50,000</span>
                                        <span className="period">/month</span>
                                    </div>
                                    <div className="pricing-features">
                                        <div className="feature">
                                            <i className="fas fa-check"></i>
                                            <span>Access to 5 talent profiles</span>
                                        </div>
                                        <div className="feature">
                                            <i className="fas fa-check"></i>
                                            <span>Basic contact information</span>
                                        </div>
                                        <div className="feature">
                                            <i className="fas fa-check"></i>
                                            <span>Email support</span>
                                        </div>
                                    </div>
                                    <Link to="/talent-payment" className="pricing-btn">
                                        Get Started
                                    </Link>
                                </div>

                                <div className="pricing-card featured">
                                    <div className="popular-badge">Most Popular</div>
                                    <div className="pricing-header">
                                        <h4>Professional</h4>
                                        <p>Ideal for growing companies</p>
                                    </div>
                                    <div className="pricing-price">
                                        <span className="currency">₦</span>
                                        <span className="amount">100,000</span>
                                        <span className="period">/month</span>
                                    </div>
                                    <div className="pricing-features">
                                        <div className="feature">
                                            <i className="fas fa-check"></i>
                                            <span>Access to 20 talent profiles</span>
                                        </div>
                                        <div className="feature">
                                            <i className="fas fa-check"></i>
                                            <span>Full contact information</span>
                                        </div>
                                        <div className="feature">
                                            <i className="fas fa-check"></i>
                                            <span>Priority support</span>
                                        </div>
                                        <div className="feature">
                                            <i className="fas fa-check"></i>
                                            <span>Advanced search filters</span>
                                        </div>
                                    </div>
                                    <Link to="/talent-payment" className="pricing-btn">
                                        Get Started
                                    </Link>
                                </div>

                                <div className="pricing-card">
                                    <div className="pricing-header">
                                        <h4>Enterprise</h4>
                                        <p>For large organizations</p>
                                    </div>
                                    <div className="pricing-price">
                                        <span className="currency">₦</span>
                                        <span className="amount">200,000</span>
                                        <span className="period">/month</span>
                                    </div>
                                    <div className="pricing-features">
                                        <div className="feature">
                                            <i className="fas fa-check"></i>
                                            <span>Unlimited access</span>
                                        </div>
                                        <div className="feature">
                                            <i className="fas fa-check"></i>
                                            <span>Direct talent matching</span>
                                        </div>
                                        <div className="feature">
                                            <i className="fas fa-check"></i>
                                            <span>Dedicated account manager</span>
                                        </div>
                                        <div className="feature">
                                            <i className="fas fa-check"></i>
                                            <span>Custom integrations</span>
                                        </div>
                                    </div>
                                    <Link to="/talent-payment" className="pricing-btn">
                                        Get Started
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="cta-background">
                    <div className="cta-shapes">
                        <div className="shape shape-1"></div>
                        <div className="shape shape-2"></div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto text-center">
                            <div className="cta-content">
                                <h2 className="cta-title mb-4">
                                    Ready to Find Your Next <span className="gradient-text">Tech Star?</span>
                                </h2>
                                <p className="cta-subtitle mb-5">
                                    Join hundreds of companies who trust Abia Tech Hub Academy for their tech talent needs. 
                                    Start building your dream team today.
                                </p>
                                <div className="cta-actions">
                                    <Link to="/company-register" className="btn btn-primary btn-lg me-3">
                                        <i className="fas fa-rocket me-2"></i>Get Started Now
                                    </Link>
                                    <Link to="/talent-marketplace" className="btn btn-outline-light btn-lg">
                                        <i className="fas fa-users me-2"></i>Browse Talents
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TalentProgram;
